import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PropertyChargeScheduleSummaryModel } from '../../../../core/models/data/property-charge-schedule-summary.model';
import { CurrencyUtilities } from '../../../../core/utilities/currency.utilities';
import { OrgDatePipe } from '../../../../core/pipes/org-date/org-date.pipe';

@Component({
  selector: 'ms-property-charge-schedule-summary-header',
  imports: [CommonModule, FontAwesomeModule, OrgDatePipe],
  templateUrl: './property-charge-schedule-summary-header.component.html',
})
export class PropertyChargeScheduleSummaryHeaderComponent {
  public summary = input<PropertyChargeScheduleSummaryModel | undefined>(undefined);
  public isLoading = input<boolean>(false);

  public formattedTotalChargedAmount = computed(() => {
    const summaryData = this.summary();
    if (!summaryData) return '$0.00';
    return CurrencyUtilities.convertMinorUnitToDisplayFormat(
      summaryData.totalChargedAmount,
      summaryData.currency
    );
  });
}
